import { render, staticRenderFns } from "./header-tenants-selector.vue?vue&type=template&id=24a53dc4&"
import script from "./header-tenants-selector.vue?vue&type=script&lang=ts&"
export * from "./header-tenants-selector.vue?vue&type=script&lang=ts&"
import style0 from "./header-tenants-selector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports